import { Modal, Radio, Select } from "antd";
import { useEffect, useState } from "react";
import { getVersions } from "../service";
import { showToast } from "ui/components/common";
import useWsSender from "lib/wsSenderHook";

export default function ({ visible, onClose, selectedDevs }) {
  const [service, setService] = useState("nvr");
  const [version, setVersion] = useState("");
  const [versionOptions, setVersionOptions] = useState([]);
  const [selectLoading, setSelectLoading] = useState(false);
  const { sendWsRequest } = useWsSender();
  useEffect(() => {
    setSelectLoading(true);
    setVersion("");
    getVersions(service)
      .then((data) => {
        if (data.status !== 200) {
          showToast(1, "Get Version List Failed");
          return;
        }

        setVersionOptions(
          data?.data?.data?.map((item) => {
            return {
              label: item.version,
              value: item.version,
            };
          }),
        );
      })
      .finally(() => {
        setSelectLoading(false);
      });
  }, [service]);
  function doUpgrade() {
    selectedDevs.forEach(async (dev) => {
      try {
        await sendWsRequest("device.nvr.upgrade", {
          nvrUpgrade: {
            id: dev.id,
            service,
            target_version: version,
          },
        });
      } catch (e) {
        console.error(e);
        showToast(1, "Upgrade message failed to sent,id: " + dev.id);
      }
    });
    showToast(0, "Upgrade message sent,upgrade " + service + " to " + version, {
      minWidth: 200,
    });
    onClose?.();
  }
  return (
    <Modal
      title={"Upgrade to Specific Version"}
      open={visible}
      okButtonProps={{ className: "primaryButton" }}
      cancelButtonProps={{ className: "primaryButton bordered" }}
      onCancel={onClose}
      onOk={doUpgrade}
    >
      <div style={{ marginTop: "12px" }}>
        <Radio.Group
          value={service}
          onChange={(e) => setService(e.target.value)}
          options={[
            { label: "NVR", value: "nvr" },
            { label: "EDGE", value: "nvr_edge" },
            { label: "NVR_DAEMON", value: "nvr_daemon" },
          ]}
        />
      </div>
      <div style={{ marginTop: "12px" }}>
        <Select
          disabled={selectLoading}
          loading={selectLoading}
          allowClear
          style={{ width: "300px" }}
          options={versionOptions}
          value={version}
          onChange={(v) => setVersion(v)}
        />
      </div>
    </Modal>
  );
}
